// ── Confirm — окно «Точно?» перед необратимым действием ──────────────────────
// Кнопка подтверждения названа самим действием («Удалить», «Очистить»), для
// опасных действий — красная и в фокусе: Enter подтверждает, Esc — отмена.
//   <Confirm title="Очистить статистику?" body="…" confirmLabel="Очистить" danger
//            onConfirm={clear} onClose={() => setAsk(false)} />

import { useEffect, useRef } from 'react';
import Icon from '../Icon';
import { t } from '../i18n';
import Button from './Button';
import { Modal } from './Dialog';
import { usePalette } from './theme';

export default function Confirm({ title, body, confirmLabel, cancelLabel, danger = true, onConfirm, onClose, C: Cp }) {
  const C = usePalette(Cp);
  const okRef = useRef(null);
  useEffect(() => { okRef.current?.focus(); }, []);
  const confirm = () => { onConfirm?.(); onClose?.(); };
  return (
    <Modal size="sm" onClose={onClose}
      title={<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>{danger && <span style={{ color: C.danger, display: 'inline-flex' }}><Icon n="alert" s={18} /></span>}{title}</span>}
      footer={<>
        <Button onClick={onClose}>{cancelLabel || t("Отмена")}</Button>
        <Button ref={okRef} variant="primary" danger={danger} onClick={confirm}>{confirmLabel || t("Удалить")}</Button>
      </>}>
      {body && <div style={{ fontSize: 14, color: C.mid, lineHeight: 1.5, whiteSpace: 'pre-line', overflowWrap: 'break-word' }}>{body}</div>}
    </Modal>
  );
}
